import { typed } from "mathjs";
import { slope } from "./slope";

export const intercept = typed("intercept", {
  "Array, Array": function (x, y) {
    const n = x.length;
    const sumX = x.reduce((a, b) => a + b, 0);
    const sumY = y.reduce((a, b) => a + b, 0);
    const m = slope(x, y);

    return (sumY - m * sumX) / n;
  },
});
